// The window event that call-ui.js dispatches when the after-call screen closes. Its detail is { callId, cause, busy }, where busy is callState.isBusy().
export const AFTER_CALL_CLOSED_EVENT = 'call-after-closed';

// A report close replaces the after-call screen with the report modal.
export const AfterCallCloseCause = {
    CLOSE: 'close',
    REPORT: 'report',
};
